export default "__VITE_ASSET__BoUeuZWn__"